document.addEventListener('DOMContentLoaded', () => {

  initVideoCarousels();

  document.addEventListener('shopify:section:load', (e) => {
    if (e.target.querySelector('.video-review-carousel')) {
      initVideoCarousels();
    }
  });
});

function initVideoCarousels() {

  const carousels = document.querySelectorAll('.video-review-carousel');

  carousels.forEach((section) => {

    if (section.dataset.initialized === 'true') return;
    section.dataset.initialized = 'true';

    const track = section.querySelector('.vrc-track');
    const dots = section.querySelector('.vrc-dots');
    const prev = section.querySelector('.vrc-arrow--prev');
    const next = section.querySelector('.vrc-arrow--next');
    const items = section.querySelectorAll('.vrc-item');
    const modal = section.querySelector('.vrc-modal');
    const modalVideo = section.querySelector('.vrc-modal-video');
    const modalClose = section.querySelector('.vrc-modal-close');

    if (!track || !track.children.length) return;

    const pages = Array.from(track.children); 
    let pageCount = pages.length;
    let currentPage = 0;

    function initDots() {
      if (!dots) return;
      dots.innerHTML = '';
      
      if (pageCount <= 1) {
        if (prev) prev.style.display = 'none';
        if (next) next.style.display = 'none';
        return;
      }

      for (let i = 0; i < pageCount; i++) {
        const li = document.createElement('li');
        li.dataset.index = i;
        li.setAttribute('role', 'button');
        li.setAttribute('aria-label', `Go to page ${i + 1}`);
        li.addEventListener('click', () => scrollToPage(i));
        dots.appendChild(li);
      }
      updateDots();
    }

    function scrollToPage(p) {
      if (p < 0) p = 0;
      if (p >= pageCount) p = pageCount - 1;
      if (pages[p]) {
        track.scrollTo({
          left: pages[p].offsetLeft,
          behavior: 'smooth'
        });
        currentPage = p;
        updateDots();
      }
    }

    function updateDots() {
      if (!dots) return;
      Array.from(dots.children).forEach((d, i) => {
        d.classList.toggle('active', i === currentPage);
        if (i === currentPage) {
             d.setAttribute('aria-current', 'true');
        } else {
             d.removeAttribute('aria-current');
        }
      });
    }

    if (prev) prev.addEventListener('click', () => scrollToPage(currentPage - 1));
    if (next) next.addEventListener('click', () => scrollToPage(currentPage + 1));
    
    initDots();

    let startX = 0;
    let isDragging = false;
    let isMouseDown = false;

    track.addEventListener('touchstart', (e) => {
      startX = e.touches[0].clientX;
      isDragging = true;
    }, { passive: true });

    track.addEventListener('touchend', (e) => {
      if (!isDragging) return;
      const diff = startX - e.changedTouches[0].clientX;
      handleSwipe(diff);
      isDragging = false;
    });

    track.addEventListener('mousedown', (e) => {
      startX = e.clientX;
      isMouseDown = true;
    });

    track.addEventListener('mousemove', (e) => {
      if (!isMouseDown) return;
      e.preventDefault();
    });

    track.addEventListener('mouseup', (e) => {
      if (!isMouseDown) return;
      const diff = startX - e.clientX;
      if (Math.abs(diff) > 50) {
        handleSwipe(diff);
        setTimeout(() => { isMouseDown = false; }, 0);
      } else {
        isMouseDown = false;
      }
    });
    
    track.addEventListener('mouseleave', () => {
      isMouseDown = false;
      isDragging = false;
    });

    function handleSwipe(diff) {
      if (diff > 50) scrollToPage(currentPage + 1); 
      else if (diff < -50) scrollToPage(currentPage - 1);
    }

    items.forEach((it) => {
      it.addEventListener('click', (e) => {

        const url = it.dataset.videoUrl;
        if (!url) return;

        document.body.style.overflow = 'hidden'; 
        
        let videoHtml = '';
        
        if (/youtube\.com\/|youtu\.be\//.test(url)) {
          let videoId = '';
          if (url.includes('v=')) {
            videoId = url.split('v=')[1].split('&')[0];
          } else if (url.includes('youtu.be/')) {
            videoId = url.split('youtu.be/')[1].split('?')[0];
          } else if (url.includes('embed/')) {
            videoId = url.split('embed/')[1].split('?')[0];
          }
          
          if (videoId) {
            videoHtml = `<iframe src="https://www.youtube.com/embed/${videoId}?autoplay=1&enablejsapi=1" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen></iframe>`;
          }
        } else {
          videoHtml = `<video controls autoplay playsinline><source src="${url}" type="video/mp4"></video>`;
        }

        if (modalVideo) modalVideo.innerHTML = videoHtml;
        if (modal) modal.setAttribute('aria-hidden', 'false');
      });
    });

    if (modalClose && modal) {
      modalClose.addEventListener('click', closeModal);
      modal.addEventListener('click', (e) => {
        if (e.target === modal) closeModal();
      });
    }

    function closeModal() {
      if (modal) modal.setAttribute('aria-hidden', 'true');
      if (modalVideo) modalVideo.innerHTML = ''; 
      document.body.style.overflow = ''; 
    }
  });
}